import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=4777e16e&scoped=true"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"
import style0 from "./Document.vue?vue&type=style&index=0&id=4777e16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4777e16e",
  null
  
)

export default component.exports